import { useState, useRef, useEffect } from 'react';
import { useTranslation} from 'react-i18next';

const FLAG_BY_LANG = {
  ky: '/ky.png',
  ru: '/ru.png',
  en: '/en.png',
};

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [i18n]);

  const currentLang = (i18n.language || 'ky').split('-')[0];
  const currentFlag = FLAG_BY_LANG[currentLang] || FLAG_BY_LANG.ky;

  const onPick = (lang) => {
    i18n.changeLanguage(lang);
    setOpen(false);
  };

  return (
    <ul className="navbar-nav change-language" ref={ref}>
      <li className="nav-item dropdown">
        <button
          type="button"
          className="nav-link dropdown-toggle toggle-block btn btn-link p-0"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <div className="lang-logo">
            <img src={currentFlag} alt="language logo" />
          </div>
        </button>

        <ul className={`dropdown-menu lang-toggle ${open ? 'show' : ''}`}>
          <li className="dropdown-item link-item" onClick={() => onPick('ky')}>
            <div className="lang-logo"><img src="/ky.png" alt="Кыргызча" /></div>
          </li>
          <li className="dropdown-item link-item" onClick={() => onPick('ru')}>
            <div className="lang-logo"><img src="/ru.png" alt="Русский" /></div>
          </li>
          <li className="dropdown-item link-item" onClick={() => onPick('en')}>
            <div className="lang-logo"><img src="/en.png" alt="English" /></div>
          </li>
        </ul>
      </li>
    </ul>
  );
}
